<template>
    <div class="communityAnalysis spackage padding-20">
        <div class="infohead flex">
            <div class="blod">基本数据</div>
            <el-select
                v-model="groupnameList"
                multiple
                collapse-tags
                placeholder="请选择社群（最多5个）"
                @change="infoSelect"
                :multiple-limit= 5
                style="width: 412px">
                <el-option
                    v-for="item in options"
                    :key="item.innerid"
                    :label="item.name"
                    :value="item.innerid">
                </el-option>
            </el-select>
        </div>
        <div class="key-data">
            <div class="box box-shadow bgc" v-for="(item,index) in keyData" :key="index">
                <el-tooltip class="item" effect="dark" :content="item.tooltip" placement="top-start" style="visibility: hidden">
                    <i class="el-icon-warning"></i>
                </el-tooltip>
                <div class="summary">{{item.title}}</div>
                <div class="content">
                    <div class="num">{{item.total}}</div>
                    <i class="icon overflow" :class="[item.type?'icon_index_1':'icon_index_2']"></i>
                </div>
                <p class="desc">{{item.ltooltip}}<span>{{item.alltotal}}</span></p>
            </div>
        </div>

       <div class="data-table">
           <div class="trendTitle">
               <el-tabs v-model="activeTitleName" @tab-click="handleTabClick" class="trendName">
                   <el-tab-pane label="新增用户" name="first"></el-tab-pane>
                   <el-tab-pane label="订单量" name="user"></el-tab-pane>
                   <el-tab-pane label="订单金额" name="money"></el-tab-pane>
               </el-tabs>
               <el-tabs v-model="activeName" @tab-click="handleClick" class="tablist">
                   <el-tab-pane label="今日" name='0'></el-tab-pane>
                   <el-tab-pane label="昨日" name='1'></el-tab-pane>
                   <el-tab-pane label="近7日" name='6'></el-tab-pane>
                   <el-tab-pane label="近30日" name='29'></el-tab-pane>
                   <el-tab-pane name="zdy">
                    <span slot="label">
                        <div class="block">
                            <el-date-picker class="dateInput" v-model="param.date" type="daterange" align="right" unlink-panels
                                            range-separator="至" start-placeholder="开始日期" end-placeholder="结束日期" @change="handleClick">
                            </el-date-picker>
                          </div>
                    </span>
                   </el-tab-pane>
               </el-tabs>
           </div>
           <!--<el-tabs v-model="activeName" @tab-click="handleClick">-->
           <!--</el-tabs>-->
           <lineReport :lineDatas="lineDatas" class="lineDatas"></lineReport>
       </div>
    </div>
</template>

<script>
    import { getAgbBasicdata, searchAssociationList, getAgbBasiclinechartdata } from 'api/cPurchaseApi'
    import fecha from 'element-ui/src/utils/date';
    import {mapGetters, mapActions} from 'vuex'
    import LineReport from 'base/echarts/lineReportStar'
    export default {
        name: "CommunityAnalysis",
        data() {
            return {
                keyData: [
                    {'title':'今日新增用户数', total: 0, type:true, tooltip:'今日新增用户数', ltooltip: '累计用户数', alltotal: 0},
                    {'title':'今日订单数', total: 0, type:true, tooltip:'今日订单数', ltooltip: '累计订单数', alltotal: 0},
                    {'title':'今日订单额', total: 0, type:false, tooltip:'今日订单额', ltooltip: '累计订单金额', alltotal: 0}
                ],
                options: [],    // 社群分组列表
                groupnameList: [], // 选择的社群分组item
                getAgbBasicdataApi: {   // 社群基本信息
                    innerids: ''
                },
                param: {
                    date: [],
                    status: '1' // 1今日 2昨日 3近7日 4近30天 5自定义
                },
                activeTitleName: 'first',
                activeName: '0',
                lineDatas: {id: 'index', subText: '', xdata: [], data: [], legend: {}},
                tpm: {  
                    type: 1,
                    beginTime: '',
                    endTime: '',
                    innerids: ''
                    }
                }
            },
            mounted() {
                this.info() // 获取基础数据
                this.indexInfo()    // 获取折线图数据
                this.searchAssociationList()    // 获取社群分组
            },
            activated: function() {
                // this.indexInfo()
            },
        methods: {
            info() {    // 基本用户数据
                console.log('info -> getAgbBasicdataApi',this.getAgbBasicdataApi)
                this.setLoading(true)
                getAgbBasicdata({    // 获取社群基本信息
                    data: this.getAgbBasicdataApi,
                    success:data => {
                        this.setLoading(false)
                        this.$nextTick(() => {
                            
                            this.keyData[0].total = data.data.todayaddusercount // 今日新增用户数
                            this.keyData[0].alltotal = data.data.allusercount   // 累计用户数
                            
                            this.keyData[1].total = data.data.todayordercount   // 今日订单数
                            this.keyData[1].alltotal = data.data.allordercount  // 累计订单数
                           
                            this.keyData[2].total = "¥" + data.data.todaymoneycount    // 今日订单额
                            this.keyData[2].alltotal = "¥" + data.data.allmonetcount   // 累计订单额
                        })
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            infoSelect(even) {  // 信息栏顶部select发生变化触发加载
                this.getAgbBasicdataApi.innerids = ''

                // 循环社群分组进行拼接  格式为 inner,inner,inner 数据为最后一个时 则不拼接 ,
                for (let i = 0; i < this.groupnameList.length; i++) {   

                    if ( i == this.groupnameList.length - 1) {
                         this.getAgbBasicdataApi.innerids += this.groupnameList[i]
                    } else {
                        this.getAgbBasicdataApi.innerids += this.groupnameList[i] + ','
                    }
                }

                // 获取基本信息
                this.info()

                // 判断是否有时间存在 
                if (this.getAgbBasicdataApi.beginTime || this.getAgbBasicdataApi.endTime) {
                    let tpm = {
                        beginTime: this.getAgbBasicdataApi.beginTime,  // 开始时间
                        endTime:  this.getAgbBasicdataApi.endTime     // 结束时间
                    }
                     this._getIndexData(tpm) // 调用获取折线图api
                } else {
                    // 获取折线图信息
                    this.indexInfo()
                }
               
                // console.log('infoSelect -> getAgbBasicdataApi',this.getAgbBasicdataApi)

            },
            handleTabClick(tab, event) {   // 新增用户/订单量/订单金额 点击切换  
                
                if (event.srcElement.className !== "el-tabs__item is-top is-active") {  //  选中情况下 点击按钮时不触发当前事件

                    let date = new Date(),   // 时间取得
                        tpm = this.tpm       // api 接口请求参数

                    if (tpm.beginTime === '' && tpm.endTime === '') {   // 开始 | 结束时间没选择时，默认时间为当天
                        tpm.endTime = tpm.beginTime = this._time(date.getTime())
                    }

                    if (tab.name === 'first') { 

                        tpm.type = 1    // 新增用户 类别
                    } else if (tab.name === 'user' || tab.name === 'money') {

                        tpm.type = 2    // 订单量 与 订单金额 类别
                    }

                    this._getIndexData(tpm)
                }
            },
            handleClick(tab, event) {   // 今日/昨日/近7日 ... /自定义   时间点击切换

                if (tab.name !== 'zdy') {   // 不等于自定义时执行

                    if (event.srcElement.className !== "el-tabs__item is-top is-active") {  // 选中情况下 点击按钮时不触发当前事件

                        let date = new Date(),  // 时间 
                            tpm = this.tpm      // api 接口请求参数

                        this.param.type = tab.type  // 获取类别

                        if (tab.name === '0') { // 为今日
                            tpm.beginTime = this._time(date.getTime())

                        } else {    // 不为今日

                            tpm.beginTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        }

                        if (tab.name === '1') { // 为昨日
                            tpm.endTime = this._time(date.getTime() - 3600 * 1000 * 24 * parseInt(tab.name))
                        } else {    // 不为昨日
                            tpm.endTime = this._time(date.getTime())
                        }

                        this._getIndexData(tpm) // 请求折线图
                    }
                }
            },
            indexInfo() {  //  调用折线图 api
                // console.log('indexInfo -> getAgbBasicdataApi',this.getAgbBasicdataApi)
                const date = new Date(),    // 获取时间
                    tpm = {
                        beginTime: this._time(date.getTime()),  // 开始时间
                        endTime: this._time(date.getTime())     // 结束时间
                    }
                this._getIndexData(tpm) // 调用获取折线图api
            },
            _getIndexData(tmp) {    // 折线图 api
            // console.log('_getIndexData -> getAgbBasicdataApi',this.getAgbBasicdataApi)
                let data = {
                    type: tmp.type?tmp.type:1,  // 类型
                    innerids: this.getAgbBasicdataApi.innerids, // 社群innerid
                    beginTime: tmp.beginTime || tmp.begintime,    // 查询开始时间
                    endTime: tmp.endTime || tmp.endtime           // 查询结束时间
                }
                this.getAgbBasicdataApi = data

                this.setLoading(true)
                getAgbBasiclinechartdata({  // 折线图 api
                    data: data,
                    success: data => {

                        // 初始化数据
                        this.lineDatas =  {id: 'index', subText: '', xdata: [], data: [], legend: {}}
                      
                        this.setLoading(false)
                        let usercountlist = this._feachList(this.activeTitleName, data),    // 返回折线图数据   
                            assnamelist = data.data.assnamelist, // 折线图顶部展示条
                            usercountlistLen = usercountlist.length,  // 数据长度
                            colorList = ['#409EFF','#41CCF0','#67C23A','#ACDF84','#F5CC4D'] // 折线颜色
                        // 数据表
                        this.lineDatas.xdata = data.data.datelist  // x 坐标初始化 
                        // this.lineDatas.xdata = ['2019-10-11','2019-10-12','2019-10-13','2019-10-14','2019-10-15']

                        // 初始化数据
                        for (let i = 0; i < usercountlist.length; i++) {
                            this.lineDatas.data.push({
                                title: usercountlist[i].name,  // 标题
                                color: colorList[i],        // 颜色
                                list: usercountlist[i].data    // 折线图数据
                                // list: [Math.random() * 100,Math.random() * 100,Math.random() * 100,Math.random() * 100,Math.random() * 100]
                            })
                        }

                        this.lineDatas.legend = {   // 设置顶部显示条
                            left: 'center',
                            data: assnamelist   // 顶部数据
                        }

                        this.$nextTick(()=>{
                            // this.keyData = this.keyData
                            this.lineDatas = this.lineDatas
                        })
                        //     this.lineDatas.subText = '用户'
                    },
                    error: data => {
                        this.setLoading(false)
                        this.$message.error(dta.msg)
                    }
                })
            },
            _feachList(type, data) {  // 循环数据表   
                console.log('type', type)
                let txt = []
                // 判断类别
                switch (type) {
                    case 'first':
                        txt = data.data.usercountlist
                        break
                    case 'user':
                         txt = data.data.ordercountlist
                        break
                    case 'money':
                         txt = data.data.monetcountlist
                        break
                }
                console.log(txt)
                return txt
            },
            _time(time) {

                const temp = new Date(time);
                return fecha.format(temp, 'yyyy-MM-dd');

                time = new Date(time)   // 转换时间
                // 时间换算
                var year = time.getFullYear(),  // 年
                    month= time.getMonth()+1,   // 月
                    date= time.getDate(),       // 日
                    hour= time.getHours(),      // 时
                    minute = time.getMinutes(), // 分
                    second = time.getSeconds()  // 秒
                return year+"-"+month+"-"+date;
            },
            
            searchAssociationList() {   // 社群分组接口
                this.setLoading(true)
                searchAssociationList({
                    data: this.getAgbBasicdataApi,  // 调用API
                    success:data => {
                        this.setLoading(false)
                        this.options = data.data.content    // 初始化社群分组数据
                    },
                    error:data => {
                        this.$message.error(data.msg)
                        this.setLoading(false)
                    }
                })
            },
            ...mapActions(['setLoading'])
        },
        watch: { // 自定义时间发生变化触发
            'param.date': {
                handler(newV, oldV) {   // 执行方法
                    let tpm = this.tpm 
                    tpm.beginTime = this._time(newV[0]) // 开始时间
                    tpm.endTime = this._time(newV[1])   // 结束时间
                    this._getIndexData(tpm) // 接口执行
                }
            },
            deep: true
        },
        components: {
            LineReport // 折线图组件
        },
        computed: {
            ...mapGetters(['loading'])
        }
    }
    
</script>

<style lang="scss" type="text/scss" rel="stylesheet/scss">
    .communityAnalysis {
        .bold {
            font-weight: bold;
        }
        .infohead {
            background: #fff;
            padding: 10px 20px;
        }
        .flex {
            display: flex;
            flex-wrap: nowrap;
            -ms-flex-wrap: nowrap;
            justify-content: space-between;
            line-height: 32px;

            .el-input__icon {
                line-height: normal
            }
        }
        .trendTitle{
            margin-top: 24px;
            margin-bottom: 24px;
            /*padding-top: 4px;*/
            padding: 4px 10px 0 10px;
            height: 43px;
            border-bottom: solid 2px #E4E7ED;
            .trendName{
                flex-grow: 1;
            }
            .el-tabs__item {
                height: 45px;
            }
            .trendName,
            .tablist {
                float: left;
            }
            .tablist {
                float: right;
                /*width: calc(100% - 115.45px);*/
                .el-tabs__nav {
                    float: right;
                }
                .el-tabs__active-bar{
                    background: none!important;
                }
            }
            .el-tabs__nav{
                margin-left:20px;
                margin-right:20px;
            }
            .el-range-editor.el-input__inner{
                padding: 3px 5px;
            }
            .el-range-editor.el-input__inner{
                height: 32px;
                line-height: 32px;
            }
            .el-date-editor .el-range__icon{
                line-height: 26px;
            }
            .el-date-editor .el-range-separator{
                line-height: 26px;
            }
        }
        .key-data{
            display: block;
            margin-top: 14px;
            width: 100%;
            .item {
                float: right;
                width: auto;
                color: #C0C4CC;
                font-size: 14px;
                text-align: right;
                box-sizing: border-box;
            }
            .summary {
                clear: both;
                margin-left: 20px;
                margin-top: 6px;
                font-size: 14px;
            }
            .desc {
                margin-top: 55px;
                margin-left: 20px;
                font-size: 12px;
                color: #001529;
                span {
                    color: #409EFF;
                    padding-left: 5px
                }
            }
            .content{
                .num {
                    float: left;
                    margin-left: 20px;
                    margin-top: 12px;
                    font-size: 30px;
                    color: #409EFF;
                }
                .icon{
                    float: right;
                    margin-top: 12px;
                    margin-right: 10px;
                    min-width: 34px;
                    min-height: 34px;
                    width: 34px;
                    height: 34px;
                }
                .icon.icon_index_1 {
                    // background: url("../../common/images/planetCommunity/index-1.png") center no-repeat;
                    background-size: 34px;
                }
                .icon.icon_index_2 {
                    // background: url("../../common/images/planetCommunity/index-2.png") center no-repeat;
                    background-size: 34px;
                }
            }

            .box {
                padding: 10px;
                display: inline-block;
                margin-left: 40px;
                width: calc((100% - 80px) / 3);
                height: 120px;
                box-sizing: border-box;
            }
            .box:nth-child(1) {
                margin-left: 0;
            }
        }
        .data-table {
            margin-top: 20px;
            padding: 0 0;
            padding-bottom: 30px;
            box-sizing: border-box;
            background: #fff;

            .lineDatas {
                #index div {
                    width: 100px;
                }
                canvas {
                    width: 100%;
                }
            }
        }
    }
    /*菜单样式优化*/
    .el-menu-item-group__title{
        padding: 0 0 0 0;
    }
    .el-submenu .el-menu-item{
        padding-left: 45px!important;
    }
</style>